import Button from 'components/_UI/Button';
import Icon from 'components/_UI/Icon';
import React from 'react'
import { Link } from 'react-router-dom';
import paths from 'routes/paths';
import styled from 'styled-components'
import { Row } from 'styled/alignment/Row';
import colors from 'theme/colors';
import sizes from 'theme/sizes';

export default function Navbar() {
  return (
    <NavbarContainer>
        <Link to={paths.home}>
            <IconContainer>
                <Icon name='home' color={colors.nightLight}/>
            </IconContainer>
        </Link>

        <Link to={paths.home}>
            <IconContainer>
                <Icon name='notification' color={colors.nightLight}/>
            </IconContainer>
        </Link>
        
        <Link to={paths.home}>
            <IconContainer>
                <Icon name='fire-filled' color={colors.nightLight}/>
            </IconContainer>
        </Link>

        <Link to={paths.home}>
            <IconContainer>
                <ProfileImage src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRHC1G7Fb6ufjKySnzkC2XoUwshtunDkIgdHeKxrCQPfIk8xyUqfskIwysJh6kHEWKKx1k&usqp=CAU' />
            </IconContainer>
        </Link>
    </NavbarContainer>
  )
}

const NavbarContainer = styled(Row)`
    width: 100%;
    height: 70px;
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 12px;
    align-items: center;
    background: ${colors.neutralLight};
    border: 1px solid ${colors.occasionalGrey};
    border-radius: ${sizes.tiny} ${sizes.tiny} ${sizes.none} ${sizes.none};
    justify-content: space-around;
    box-shadow: 0px 0px 12px #ccc;
`;

const IconContainer = styled.button`
    width: 28px;
    height: 28px;
    background: ${colors.neutralLight};
`

const ProfileImage = styled.img`
    width: 100%;
    height: 100%;
    border-radius: 50%;
`
